// ✅ Performance optimized Skills.js without lazy loading error

import { Player } from '@lottiefiles/react-lottie-player';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import colorSharp from "../assets/img/color-sharp.png";
import animationFullstack from "../assets/animations/fullstack.json";
import animationCloud from "../assets/animations/cloud.json";
import animationML from "../assets/animations/ml.json";
import animationFrontend from "../assets/animations/frontend.json";
import animationBackend from "../assets/animations/backend.json";
import animationDatabase from "../assets/animations/database.json";

export const Skills = () => {
  const responsive = {
    superLargeDesktop: { breakpoint: { max: 4000, min: 3000 }, items: 5 },
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 3 },
    tablet: { breakpoint: { max: 1024, min: 768 }, items: 2 },
    mobile: { breakpoint: { max: 768, min: 0 }, items: 1 }
  };

  const skills = [
    { title: "Full Stack Development", animation: animationFullstack },
    { title: "Cloud (AWS & GCP)", animation: animationCloud },
    { title: "Machine Learning", animation: animationML },
    { title: "React & Django", animation: animationFrontend },
    { title: "Node.js & APIs", animation: animationBackend },
    { title: "PostgreSQL & MongoDB", animation: animationDatabase },
  ];

  return (
    <section className="skill" id="skills" style={{ padding: "80px 0" }}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="skill-bx wow zoomIn">
              <h2 className="text-center">Skills</h2>
              <p className="text-center">
                My skill set bridges full stack web development, cloud platforms, and machine learning.
                I create reliable, scalable systems using modern frameworks and technologies.
              </p>
              <Carousel responsive={responsive} infinite className="skill-slider py-4">
                {skills.map((skill, index) => (
                  <div className="item text-center" key={index}>
                    <Player
                      autoplay
                      loop
                      src={skill.animation}
                      style={{ height: '120px', width: '120px', margin: '0 auto' }}
                    />
                    <h5 style={{ marginTop: "10px" }}>{skill.title}</h5>
                  </div>
                ))}
              </Carousel>
            </div>
          </div>
        </div>
      </div>
      <img className="background-image-left" src={colorSharp} alt="Background" loading="lazy" />
    </section>
  );
};
